<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import SettingsRow from './SettingsRow.svelte';
    import { SettingsApi } from './SettingsApi';
    import { api } from '../../../stores/api';
    import Separator from '../../shared/Separator.svelte';
    import { _ } from 'svelte-i18n';
    import { openModal } from 'svelte-modals';
    import ModalCredentials from './ModalCredentials.svelte';
    import ModalInfo from '../../shared/Modals/ModalInfo.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';

    let migrationInProgress: boolean = false;

    function showMigrationLogin() {
        migrationInProgress = true;
        openModal(ModalCredentials, {
            text: $_('login_to_old_lastmile'),
            onLogin: async (credentials: any) => {
                let response = await SettingsApi.migrateSettings($api, {action: 'authenticate', login: credentials.login, password: credentials.password});
                if (response.status == 'ok') {
                    setTimeout(migrateSettings.bind(null, response.customer_id, response.hash), 0);
                    return true;
                } else {
                    return $_('LastMile1-migration-'+response.message);
                }
            },
            onCancel: () => {
                migrationInProgress = false;
            }
        });
    }

    async function migrateSettings(customerId: number, hash: string) {
        let response = await SettingsApi.migrateSettings($api, {action: 'migrate', customer_id: customerId, hash: hash});
        if (response.status === 'ok') {
            openModal(ModalInfo, {
                text: $_('data_imported')
            });
        }
        migrationInProgress = false;
    }

</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('migration')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>{$_('fetch_data_from_old_lastmile')}</SettingsRowLabel>
            <SettingsRowValue>
                {#if migrationInProgress}
                    <Spinner/>
                {:else}
                    <button class="btn-main create-template" on:click={showMigrationLogin}>{$_('fetch')}</button>
                {/if}
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>

<style>
    .btn-main {
        /*background-color: #1c5dc7; !* var(--analytics-green); *!*/
        /*color: white;*/
        padding: 0 12px;
        border: none;
        cursor: pointer;
        min-width: 140px;
        height: 28px;
        border-radius: 14px;
        position: relative;
        font-size: 14px;
        font-weight: 600;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
